import {gsap} from "gsap";
import RentalAccordion from "../accordion/RentalAccordion";
import App from "../../../../templates/src/App/App";

const RentalVehicle = {
    init(animate) {
        this.el = $('[module="rental"][section="vehicle"]');
        if (!this.el.length) return;

        this.selectButton = this.el.find('.vehicle button.next')
        this.filter = this.el.find('[block="filter"]');
        this.filterForm = this.el.find('form.filter');
        this.filterBtn = this.el.find('.filterBtn');
        this.closeBtn = this.el.find('header .close');
        this.vehicles = this.el.find('[block="cars"] .vehicle')

        this.bind();
        if (animate) this.animate();
    },

    bind() {
        this.selectButton.on('click', this.selectVehicle);
        this.filterBtn.on('click', () => this.openFilter());
        this.closeBtn.on('click', () => this.closeFilter());
        this.filterForm.on('change', 'input', () => this.vehicleFilterInputs())
    },

    animate() {
        gsap.from(this.vehicles, {opacity: 0, y: 100, stagger: 0.15, duration: 0.7, clearProps:true});
        if(App.isMobile) return;
        gsap.from(this.filter, {opacity: 0, x: -100, duration: 1, clearProps:true})
    },

    openFilter() {
        console.log(this)
        this.filter.addClass('active');
    },

    closeFilter() {
        this.filter.removeClass('active');
    },

    selectVehicle(evt) {
        const vehicle = $(this).closest('.vehicle')
        const vehicleId = vehicle.attr('item');
        const url = "/" + window.T.rental.base_url + "/" + window.T.rental.sections.insurance.url;

        vehicle.addClass('selected').siblings().removeClass('selected');
        Rental.load(url, {vehicle: vehicleId}, 1);
        RentalAccordion.headers.filter('.disabled').removeClass('disabled');
    },

    vehicleFilterInputs() {
        const formInputs = this.filterForm.serializeArray()

        const filters = formInputs.reduce((filter, {name, value}) => {
            if (filter[name]) {
                filter[name].push(value)
            } else {
                filter[name] = [value]
            }
            return filter
        }, {})

		// window.localStorage.setItem('filters', JSON.stringify(filters));

        this.vehicleFilter(filters)
    },

    vehicleFilter(filter) {
        const hash = rentalHash ? `?hash=${rentalHash}` : ''
        if (this.isLoading) return;

        $.ajax({
            type: 'POST',
            url: `/modules/rental/rental.filter.php${hash}`,
            data: JSON.stringify(filter),
            contentType: 'application/json',
            dataType: 'html',
            beforeSend: () => {
                this.isLoading = true;
            },
            success: (response) => {
                const parent = this.el.parent()
                this.el.remove()
                parent.append(response)
                this.init();
                this.isLoading = false;
            },
            error: (xhr, status, error) => {
                console.error('Error:', error);
                // Handle error here if needed
            }
        })
    },
	//
	// restoreFilter() {
	// 	const filters = JSON.parse(window.localStorage.getItem('filters'));
	//
	// 	for (const [key, values] of Object.entries(filters)) {
	// 		console.log(key, values)
	//
	// 		values.forEach((value) => {
	// 			$(`[block="filter"] [name="${key}"][value="${value}"]`).prop('checked', true);
	// 		})
	// 	}
	// }
}
export default RentalVehicle;